import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';

const LAYOUT = {
  LIST: "list",
  GRID: "grid"
};
const LAYOUTS = {
  LIST: "LIST",
  GRID: "GRID"
};
var BACKGROUND_TYPES = /* @__PURE__ */ ((BACKGROUND_TYPES2) => {
  BACKGROUND_TYPES2["COLOR"] = "COLOR";
  BACKGROUND_TYPES2["IMAGE"] = "IMAGE";
  BACKGROUND_TYPES2["GRADIENT"] = "GRADIENT";
  return BACKGROUND_TYPES2;
})(BACKGROUND_TYPES || {});
const BACKGROUND_PRESETS = {
  ["COLOR" /* COLOR */]: [
    "#EF4538",
    "#F96132",
    "#FAAD4D",
    "#31B778",
    "#488FFE",
    "#11428D",
    "#6C49EF",
    "#8C0F7A"
  ],
  ["IMAGE" /* IMAGE */]: [
    "https://static.wixstatic.com/media/2dfdd3_03c2331b19bb41108b34938edf8951dd~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_df028f9258cf4fe0a1b7f75a3916def1~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_b120b7d9cffd4645bb143beadef13c56~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_1977932e94064f168abaaa2c04b678a5~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_17b428ae1fb14736a2ab30994620ee62~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_934a080451cd4b3eb6e7c9485a07972c~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_0b440a1138ba4c99bc954eb4d06ec0ad~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_395a5522e3474b3ca34194633e90ea81~mv2.jpg"
  ],
  ["GRADIENT" /* GRADIENT */]: [
    {
      angle: 45,
      startColor: "#EF4538",
      lastColor: "#488FFE"
    },
    {
      angle: 45,
      startColor: "#F96132",
      lastColor: "#FAAD4D"
    },
    {
      angle: 45,
      startColor: "#31B778",
      lastColor: "#FAAD4D"
    },
    {
      angle: 45,
      startColor: "#0D6546",
      lastColor: "#31B778"
    },
    {
      angle: 45,
      startColor: "#488FFE",
      lastColor: "#8C0F7A"
    },
    {
      angle: 45,
      startColor: "#11428D",
      lastColor: "#488FFE"
    },
    {
      angle: 45,
      startColor: "#6C49EF",
      lastColor: "#31B778"
    },
    {
      angle: 45,
      startColor: "#8C0F7A",
      lastColor: "#FAAD4D"
    }
  ].map((value) => JSON.stringify(value))
};
const OPTION_IMAGES_POOL = [
  "https://static.wixstatic.com/media/fb62d9f8e7824b2e90b13b971e700b92.jpg",
  "https://static.wixstatic.com/media/3a27828e768344158489df4f2c03cfb2.jpg"
];
const POLL_IMAGES_POOL = [
  "https://static.wixstatic.com/media/436483e6ed9e41fe91b9f286d2ea4efb.jpg"
];
const MEMBER_ROLES = {
  ALL: "ALL",
  SITE_MEMBERS: "SITE_MEMBERS"
};
const DIRECTION = {
  LTR: "ltr",
  RTL: "rtl"
};
const VISIBILITY = {
  ALWAYS: "ALWAYS",
  VOTERS: "VOTERS_ONLY",
  ME: "ONLY_ME"
};
const VISIBILITY_OPTIONS = {
  EVERYONE: "EVERYONE",
  VOTERS: "VOTERS",
  CREATOR: "CREATOR"
};
const DEFAULT_RICOS_COMPONENT_DATA = {
  containerData: {
    width: {
      size: "CONTENT"
    },
    alignment: "CENTER",
    textWrap: true
  },
  poll: {
    ownVotes: [],
    title: "",
    settings: {
      permissions: {
        view: VISIBILITY_OPTIONS.VOTERS,
        vote: MEMBER_ROLES.ALL,
        allowMultipleVotes: false
      },
      showVoters: true,
      showVotesCount: true
    },
    options: []
  },
  layout: {
    poll: {
      type: LAYOUTS.LIST,
      direction: DIRECTION.LTR.toUpperCase(),
      enableImage: true
    },
    options: {
      enableImage: false
    }
  },
  design: {
    poll: {
      background: {
        type: "IMAGE" /* IMAGE */,
        image: { src: { url: getRandomValue(BACKGROUND_PRESETS["IMAGE" /* IMAGE */]) } }
      },
      borderRadius: 0
    },
    options: {
      borderRadius: 0
    }
  }
};

function getRandomValue(pool) {
  return pool[Math.floor(Math.random() * pool.length)];
}
function toBackgroundString(background, backgroundType, width, height) {
  var _a, _b;
  switch (backgroundType) {
    case BACKGROUND_TYPES.GRADIENT:
      try {
        const { gradient } = background;
        return `linear-gradient(${gradient.angle}deg, ${gradient.startColor}, ${gradient.lastColor})`;
      } catch (error) {
        console.error(error);
        return background;
      }
    case BACKGROUND_TYPES.IMAGE:
      if (!width || !height) {
        return null;
      }
      const URL = (_b = (_a = background.image) == null ? void 0 : _a.src) == null ? void 0 : _b.url;
      const imageSrc = getScaleImageSrc(URL, width, height);
      return `url('${imageSrc}') center / cover`;
    case BACKGROUND_TYPES.COLOR:
    default:
      return background.color;
  }
}

export { BACKGROUND_TYPES as B, DEFAULT_RICOS_COMPONENT_DATA as D, LAYOUTS as L, MEMBER_ROLES as M, OPTION_IMAGES_POOL as O, POLL_IMAGES_POOL as P, VISIBILITY_OPTIONS as V, BACKGROUND_PRESETS as a, DIRECTION as b, LAYOUT as c, VISIBILITY as d, getRandomValue as g, toBackgroundString as t };
//# sourceMappingURL=helpers-d59c72d9.js.map
